<template>
  <f7-app :params="f7params" id="app">
    <f7-view>
      <transition :name="transitionName">
        <keep-alive>
          <router-view
            :class="transitionName == null ? '' : 'transitionBody'"
          ></router-view>
        </keep-alive>
      </transition>
    </f7-view>
  </f7-app>
</template>

<script>
import { getInit } from './utils/common-api.js';
window.dataLayer = window.dataLayer || [];
// 禁止手机端扩大和缩小手势
window.onload = function () {
  document.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });
  document.addEventListener('gesturestart', function (event) {
    event.preventDefault();
  });
};
export default {
  name: 'app',
  data() {
    return {
      transitionName: 'transitionRight',
      f7params: {
        name: 'vue-f7-template',
        theme: 'auto' // 主题 auto自适应; ios: 苹果; android:安卓
      },
      device_model: 'web',
      p: ''
    };
  },
  watch: {
    $route(to, from) {
      const arr = [
        '/',
        '/setEmail',
        '/authenticationCode',
        '/applyTypeChoose',
        '/nameBirthdaySex'
      ];
      if (arr.indexOf(to.path) - arr.indexOf(from.path) == 1) {
        this.transitionName = 'transitionLeft';
      } else if (arr.indexOf(from.path) - arr.indexOf(to.path) == 1) {
        this.transitionName = 'transitionRight';
      } else {
        this.transitionName = null;
      }


      var elements = document.querySelectorAll('.tip_alertModal');
      elements.forEach(function(element) {
        element.remove();
      });
      this.$f7.preloader.hide()

    }
  },
  methods: {},
  mounted() {
    if(!['z1200','z1100'].includes(this.$route.fullPath)){
      getInit('').then((res)=>{
        if(res.status){
          sessionStorage.setItem('configData',JSON.stringify(res.data));
          window.Vue.prototype.AWS_WHITELIST = {data: res.data.REGISTER.AWS_WHITELIST}
          Object.freeze(window.Vue.prototype.AWS_WHITELIST);
        }else{
          this.$cErrorDialog({
            title: '',
            left: 'cancel',
            right: 'OK',
            content: res.msg,
            cancelBtn: false //这个是启用取消按钮，
          });
        }
      })
    }

  }
};
</script>
<style lang="less">
@media only screen and (min-device-width: 320px) and (max-device-height: 568px) {
  html {
    font-size: 85.3px !important;
  }
}
@media only screen and (min-width: 320px) {
  html {
    font-size: 85.3px !important;
  }
}
@media only screen and (min-width: 360px) {
  html {
    font-size: 96px !important;
  }
}
@media only screen and (min-width: 375px) {
  html {
    font-size: 100px !important;
  }
}
@media only screen and (min-width: 411px) {
  html {
    font-size: 109.6px !important;
  }
}
@media only screen and (min-width: 414px) {
  html {
    font-size: 110.4px !important;
  }
}
.transitionBody {
  transition: all 0.3s ease-out;
}
.transitionLeft-enter,
.transitionRight-leave-active {
  -webkit-transform: translate(100%, 0);
  transform: translate(100%, 0);
}
.transitionLeft-leave-active,
.transitionRight-enter {
  -webkit-transform: translate(-100%, 0);
  transform: translate(-100%, 0);
}
.transitionLeft-enter-active,
.transitionRight-enter-active {
  //防止过渡时元素抖动
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue